import type { FC, ReactNode } from "react"

interface Props {
  backgroundColor?: string
  className?: string
  children?: ReactNode
}

interface SectionProps {
  direction?: "vertical" | "horizontal"
  className?: string
  children?: ReactNode
}

type Components = {
  Section: FC<SectionProps>
}

const Card: FC<Props> & Components = ({
  backgroundColor,
  className,
  children
}) => {
  return (
    <div
      className={`overflow-hidden shadow-sm rounded-2xl${className ? ` ${className}` : ""}`}
      style={{ backgroundColor: backgroundColor ?? "#FFFFFF" }}
    >
      {children}
    </div>
  )
}

const CardSection: FC<SectionProps> = ({
  direction = "vertical",
  className,
  children
}) => (
  <div
    className={`flex ${direction === "horizontal" ? "flex-row" : "flex-col"}${className ? ` ${className}` : ""}`}
  >
    {children}
  </div>
)

Card.Section = CardSection

export { Card }
export default Card
